'use strict';

// 
// Misc helper functions.
// 

var _ = require('underscore');

// Function to select element/s
var el = function( selector ) {
	return document.querySelectorAll(selector);
}

// Add class to element/s
var addClass = function(el, className) {
	if ( ! _.isElement(el) && _.isObject(el) ) {
		_.each(el, function(el) {
			if ( _.isElement(el) )
				addClass(el, className);
		} );
		return;
	}
	if (el.classList)
		el.classList.add(className);
	else
		el.className += ' ' + className;
}

// Function for adding event listener.
var addEventListener = function( el, eventName, handler ) {
	if ( ! _.isElement(el) && _.isObject(el) && el !== window ) {
		_.each(el, function(el) {
			if ( _.isElement(el) )
				addEventListener(el, eventName, handler);
		} );
		return;
	}

	if (el.addEventListener) {
		el.addEventListener(eventName, handler);
	} else {
		el.attachEvent('on' + eventName, function() {
			handler.call(el);
		});
	}
}

// Get element offset.
var getOffset = function( el ) {
	var _x = 0;
	var _y = 0;
	while( el && !isNaN( el.offsetLeft ) && !isNaN( el.offsetTop ) ) {
		_x += el.offsetLeft - el.scrollLeft;
		_y += el.offsetTop - el.scrollTop;
		el = el.offsetParent;
	}
	return { top: _y, left: _x };
}

// Test if element is visible.
var isVisible = function(el) {
	if ( ! _.isElement(el) && _.isObject(el) )
		return el[0].offsetParent !== null;

	return el.offsetParent !== null;
};

// Remove class from element/s.
var removeClass = function(el, className) {
	if ( ! _.isElement(el) && _.isObject(el) ) {
		_.each(el, function(el) {
			if ( _.isElement(el) )
				removeClass(el, className);
		} );
		return;
	}
	if (el.classList)
		el.classList.remove(className);
	else
		el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
}

module.exports.el = el;
module.exports.addClass = addClass;
module.exports.addEventListener = addEventListener;
module.exports.getOffset = getOffset;
module.exports.isVisible = isVisible;
module.exports.removeClass = removeClass;